var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"display-toggle",on:{"click":_vm.toggleDisplay}},[(_vm.sceneDisplayMode==2)?_c('img',{attrs:{"src":"/images/display-1.png","alt":""}}):_c('img',{attrs:{"src":"/images/display-2.png","alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }